import { useEffect, useRef } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
padding: 20px !important;

    > div {
        position: relative;
        top: 0;
        left: 0;

        > span {
            position: absolute;
            font-size: 10px;
            line-height: 14px;
            color: #000;
    
            &.top {
                top: 0;
                left: 50%;
                transform: translate(-50%, calc(-100% - 9px));
            }
            &.right {
                right: 0;
                top: 50%;
                transform: translate(calc(100% + 9px), -50%);
            }
            &.bottom {
                bottom: 0;
                left: 50%;
                transform: translate(-50%, calc(100% + 9px));
            }
            &.left {
                left: 0;
                top: 50%;
                transform: translate(calc(-100% - 9px), -50%);
            }
        }
    
        canvas {
            position: absolute;
        }
    
        .marker {
            position: absolute;
            width: 15px;
            height: 15px;
            border: 2px solid #fff;
            z-index: 10;
    
            .detail {
                position: absolute;
                width: 45px;
                height: 45px;
                background-color: inherit;
                left: 0;
                bottom: 0;
                transform: translate(15px, -15px);
                border-radius: 100%;
                
                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 50%;
                    height: 50%;
                    background-color: #fff;
                    z-index: 9;
                }
                
                &::after {
                    content: "";
                    display: block;
                    position: relative;
                    width: 100%;
                    height: 100%;
                    border: 2px solid #fff;
                    z-index: 10;
                    border-radius: 100%;
                    background-color: inherit;
                }
            }
        }
    
    
        .skin_img {
            position: relative;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 10px;
            max-width: 186px;
        }
    
        &::before,
        &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(255, 255, 255, 0.5);
            z-index: 1;
        }
    
        &::before {
            width: 1px;
            height: 100%;
        }
    
        &::after {
            width: 100%;
            height: 1px;
        }
    }
`;

export default function ColorPick({skinColor, colorCode}) {
    const getRGB = (HEX) => {
        return HEX.replace("#", "")
            .match(/.{2}/g)
            ?.map((replacer) => parseInt(replacer, 16) || 0);
    };

    /* 고객 정보 */
    const customerTone = colorCode; // R: COOL, Y: WARM
    const customerHex = skinColor;
    const hexToRGB = getRGB(customerHex);

    /* 이미지 그리기 */
    const img = useRef();
    const wrapper = useRef();
    const marker = useRef();

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    function findClosestColor(imageData, targetColor) {
        const { data, width, height } = imageData;
        let minDist = Infinity;
        let minCoords = { x: 0, y: 0 };

        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const index = (y * width + x) * 4;
                const pixel = [data[index], data[index + 1], data[index + 2]];
                const dist = Math.sqrt(
                    Math.pow(pixel[0] - targetColor[0], 2) +
                    Math.pow(pixel[1] - targetColor[1], 2) +
                    Math.pow(pixel[2] - targetColor[2], 2)
                );

                if (dist < minDist) {
                    minDist = dist;
                    minCoords = { x , y };
                }
            }
        }

        minCoords.x = minCoords.x - 8;
        minCoords.y = minCoords.y - 8;

        if (minCoords.x > width - 15)  {
            minCoords.x = width - 15;
        }
        if (minCoords.y > height - 15)  {
            minCoords.y = height - 15;
        }

        return minCoords;
    }


    useEffect(() => {
        if (img.current) {
            img.current.onload = function () {
                canvas.width = img.current.width;
                canvas.height = img.current.height;
                ctx.drawImage(img.current, 0, 0, img.current.width, img.current.height);
                
        
                const imageData = ctx.getImageData(0, 0, img.current.width, img.current.height);
                const targetColor = hexToRGB;
        
                const coords = findClosestColor(imageData, targetColor);
                marker.current.style.top = coords.y + "px";
                marker.current.style.left = coords.x + "px";
                marker.current.style.backgroundColor = skinColor;
            };
        }
    }, [img]);
    
    return (
        <Wrapper className="wrapper" ref={wrapper}>
            <div>
                <span className="top">따뜻한 언더톤</span>
                <span className="left">밝기</span>
                <span className="right">다크</span>
                <span className="bottom">차가운 언더톤</span>
                <img ref={img} src={process.env.PUBLIC_URL + "/image/reportV_skin_color.jpg"} className="skin_img" />
                <div className="marker" ref={marker}>
                    <div className="detail"></div>
                </div>
            </div>
        </Wrapper>
    )
}